import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { SocioIdentificadorPipe } from './socio-identificador.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        SocioIdentificadorPipe
    ],
    exports: [
        SocioIdentificadorPipe
    ],
    providers: [
        SocioIdentificadorPipe
    ]
})
export class SocioPipeModule { }
